export default "__VITE_ASSET__926f7193__"